import React, { FC } from "react";
import { Typography } from "@mui/material";
import { useStore } from "../../../store/store";
import { styled } from "@mui/material/styles";
import { convertDecimalToFraction } from "../../../util/formulas/convertDecimalToFraction";
import fractionToInt from "../../../util/fractionToInt";

const StyledDivCol = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
  alignItems: "center",
});

const StyledTypography = styled(Typography)({
  color: "#3f51b5",
  display: "inline",
  fontWeight: "bold",
});

interface SideliteProps {
  sideLites: string;
  doorPanelWidth: string;
  swingWidths: { sideliteWidth: string };
}

export function sidelite_dlo(
  sideliteWidth: string,
  material: string,
  swingDirection: string,
  isPico: boolean,
) {
  let sub = 5;
  if (material === "All Aluminum") {
    sub = swingDirection === "Inswing" ? 4.230548 : 4.803184;
  } else if (isPico) {
    //Hinge Side Sidelite Stile: 1.25
    //Non Hinge Side Sidelite Stile: 1.25
    //Primary Hinge Side Stops: 0.625
    //Lock Hinge Side Stops: 0.625
    //Total: 1.875
    sub = 3.75;
  }

  const int = fractionToInt(
    sideliteWidth.split(" ")[0],
    sideliteWidth.split(" ")[1] || "",
  );

  return convertDecimalToFraction(int - sub);
}

const Sidelites: FC<SideliteProps> = ({
  sideLites,
  doorPanelWidth,
  swingWidths,
}) => {
  const errors = useStore((state) => state.errors);
  const material = useStore((state) => state.quote.material);
  const swingDirection = useStore((state) => state.quote.swingDirection);
  const stilesAndRails = useStore((state) => state.quote.stilesAndRails);
  const isPico = stilesAndRails?.includes("Pico") ?? false;

  const dloText = sidelite_dlo(
    swingWidths.sideliteWidth,
    material,
    swingDirection || "",
    isPico
  );

  return (
    <StyledDivCol>
      {sideLites !== "none" && swingWidths.sideliteWidth && doorPanelWidth && (
        <>
          <Typography>
            <StyledTypography>
              Approximate Sidelite Panel Width(Z):
            </StyledTypography>{" "}
            {swingWidths.sideliteWidth} inches
          </Typography>

          {!errors.sideliteWidthErr && (
            <Typography style={{ paddingTop: 10 }}>
              <StyledTypography>
                Approximate Sidelite Day Light Opening(W):
              </StyledTypography>{" "}
              {dloText} inches
            </Typography>
          )}
        </>
      )}

      {errors.sideliteWidthErr && (
        <Typography style={{ color: "red" }} variant="body2">
          {errors.sideliteWidthErr}
        </Typography>
      )}
    </StyledDivCol>
  );
};

export default Sidelites;
